export default function BaseLayout(props) {
  return (
    <>
      {props.children}
    </>
  );
}
